module.exports = __webpack_public_path__ + "img/img-8.c19652d8.png";